export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8835.978f8596.jpg";